
import { Component, Vue } from "vue-property-decorator";

import {
  TokenDetails,
  RepTokenDetails,
  EMPTY_TOKEN_DETAILS
} from "@/interfaces/meeting/details";
import { readToken } from "@/services/meeting/token";
import { loadName } from "@/services/meeting/storage";
import { Roles } from "@/services/socket/meeting";

@Component
export default class UserDetailsMixin extends Vue {
  details: TokenDetails | RepTokenDetails = EMPTY_TOKEN_DETAILS;

  async created() {
    const token = new URLSearchParams(window.location.search).get("token")!;
    // Immediately available details
    this.details = readToken(token);
    // See if name is in localStorage
    const name = await loadName();
    if (name) {
      this.details.name = name;
    }
  }

  get detailsLeadName() {
    return this.details.lead_name || "";
  }

  get detailsUserName() {
    return this.details.name || "";
  }

  get detailsUserId() {
    return this.details.id;
  }

  get isSalesRep() {
    return this.details.role === Roles.SALES_REP;
  }

  get isClient() {
    return this.details.role === Roles.CLIENT;
  }
}
